import { useContext } from "react";

import { ConfigurationContext } from "./Configuration";

export function useConfiguration() {
  const { data } = useContext(ConfigurationContext);
  return data;
}
